import React, { useRef, useState } from "react";
import { Button } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import TopTitleFormComponent from "./TopTitleFormComponent";
import { getDoc, doc } from "firebase/firestore";
import { useEffect } from "react";
import { db } from "../../firebase";
import ReactToPrint from "react-to-print";

function ViewConsentAgreementUnsupervisedActivities(props) {
  const [signaturePic, setSignaturePic] = useState(null);
  const { clientId, consentId } = props;
  const [text1, setText1] = useState("");
  const [text2, setText2] = useState("");
  const [text3, setText3] = useState("");
  const [text4, setText4] = useState("");
  const [signedOn, setSignedOn] = useState(null);
  const [outingDate, setOutingDate] = useState(null);
  const [outingLocation, setOutingLocation] = useState("");
  const [outingPurpose, setOutingPurpose] = useState("");

  const printRef = useRef();

  function formatDate(timestamp) {
    const date = timestamp.toDate();
    const day = date.getDate().toString().padStart(2, "0");
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const timeZone = date
      .toLocaleString("en", { timeZoneName: "short" })
      .split(" ")
      .pop();

    return `${day} ${month} ${year} ${hours}:${minutes} ${timeZone}`;
  }

  const fetchSignatureUrl = async () => {
    // const docRef = doc(
    //   db,
    //   "ConsentAgreementUnsupervisedActivity",
    //   props.clientId
    // );

    const docRef = doc(
      db,
      "clients",
      clientId,
      "ConsentAgreementUnsupervisedActivities",
      consentId
    );
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const {
        signatureURL,
        consentIntro,
        responsibilities,
        consequences,
        acknowledgment,
        signedOn,
        outingDate,
        outingLocation,
        outingPurpose,
      } = docSnap.data();
      setSignaturePic(signatureURL);
      setText1(consentIntro);
      setText2(responsibilities);
      setText3(consequences);
      setText4(acknowledgment);
      setSignedOn(signedOn);
      setOutingDate(outingDate);
      setOutingLocation(outingLocation);
      setOutingPurpose(outingPurpose);
    } else {
      console.log(
        "No such document (ConsentAgreementUnsupervisedActivity ref)!"
      );
    }
  };

  // useEffect(() => {
  //   fetchSignatureUrl();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  useEffect(() => {
    if (!consentId) return;
    fetchSignatureUrl();
  }, [consentId]);

  return (
    <>
      <style>
        {`
          @media print {
            #printableContent {
              height: auto !important;
              overflow-y: visible !important;
            }
          }
        `}
      </style>
      <div
        // className="inputAndLabelModalContainerTitle2"
        style={{ width: "auto", height: "100%" }}
      >
        <div className="line1-modal-percent">
          <TopTitleFormComponent
            title="Consent and Agreement Form for Unsupervised Off-Site Activities"
            closemodal={props.closemodal}
          />
        </div>

        <div
          id="printableContent"
          style={{
            width: "100%",
            marginTop: "10px",
            height: "80%",
            overflowY: "scroll",
          }}
          ref={printRef}
        >
          <div className="client-name-container">
            Consent and Agreement Form for Unsupervised Off-Site Activities form
            for: {props.firstName} {props.lastName}
          </div>

          <div className="text-block" style={{ whiteSpace: "pre-line" }}>
            {text1}
          </div>
          <div
            className="text-block"
            style={{ whiteSpace: "pre-line", marginTop: "10px" }}
          >
            {text2}
          </div>
          <div
            className="text-block"
            style={{ whiteSpace: "pre-line", marginTop: "10px" }}
          >
            {text3}
          </div>
          <div
            className="text-block"
            style={{ whiteSpace: "pre-line", marginTop: "10px" }}
          >
            {text4}
          </div>

          {outingDate && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                paddingLeft: "20px",
                paddingTop: "20px",
              }}
            >
              <div style={{ fontWeight: "600", paddingRight: "5px" }}>
                Date of Outing:
              </div>{" "}
              {formatDate(outingDate)}
            </div>
          )}

          {outingLocation && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                paddingLeft: "20px",
                paddingTop: "10px",
              }}
            >
              <div style={{ fontWeight: "600", paddingRight: "5px" }}>
                Location:
              </div>
              {outingLocation}
            </div>
          )}

          {outingPurpose && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                paddingLeft: "20px",
                paddingTop: "10px",
              }}
            >
              <div style={{ fontWeight: "600", paddingRight: "5px" }}>
                Purpose:
              </div>
              {outingPurpose}
            </div>
          )}

          {/* Message de validation statique */}
          <div
            className="text-block"
            style={{ marginTop: "20px", fontStyle: "italic" }}
          >
            I fully understand and agree to the above terms.
          </div>

          <div className="signature-date-container">
            <div className="text-block-2">
              Timestamp signature:{" "}
              {signedOn ? formatDate(signedOn) : "No signature timestamp"}
            </div>
            <div className="signature-title">
              Client signature (
              <span style={{ fontWeight: "bold" }}>
                {props.firstName} {props.lastName}
              </span>
              ):
            </div>
            <img
              alt="Signature"
              className="signature-pic-roi"
              src={signaturePic}
            />
          </div>
        </div>

        <div className="line4-modal-percent-bis">
          <>
            <Button
              variant="contained"
              style={{ backgroundColor: "white", color: "black" }}
              onClick={props.closemodal}
            >
              Cancel
            </Button>

            <ReactToPrint
              trigger={() => (
                <Button variant="contained" style={{ marginLeft: "20px" }}>
                  Print
                </Button>
              )}
              content={() => printRef.current}
              onAfterPrint={props.closemodal}
            />

            {/* <Button
            variant="contained"
            onClick={handlePrint}
            style={{ marginLeft: "20px" }}
          >
            Print
          </Button> */}
          </>
        </div>
      </div>
    </>
  );
}

export default ViewConsentAgreementUnsupervisedActivities;
